{
  "id": "campaign-082",
  "name": "Quiet Rest",
  "seed": "campaign:82",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".....__.....",
    "....x__....,",
    ".i.i.__.i.i.",
    ".....__....,",
    "..L.L__L~L~.",
    ".x...__.....",
    ".....__.....",
    "....i__i....",
    "...i.__.i...",
    ".....__.....",
    ".....__~....",
    ".....__~....",
    ".......~....",
    ".......#...S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 1,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 14
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 4
    },
    {
      "kind": "repair",
      "x": 3,
      "y": 13
    }
  ],
  "generatorVersion": 3,
  "level": 82,
  "biome": "cemetery",
  "par": {
    "reel": 5387,
    "push": 4733,
    "selfPropelled": 4140,
    "tractor": 4010,
    "zeroTurn": 2859,
    "fairway": 1896
  },
  "routeTries": {
    "par": {
      "reel": 7,
      "push": 19,
      "selfPropelled": 6,
      "tractor": 3,
      "zeroTurn": 20,
      "fairway": 20
    }
  }
}
